import{ReactComponent as LogoWhite } from "./svg/educa.svg";

import authBg from "./jpg/auth-bg.jpg";
import homeBanner from "./jpg/home-banner.jpg";
import educabanner from "./jpg/pruebanueva.jpg";
import noAvatar from "./png/getImage.png";
import academyLogo from "./png/academy-logo.png";
import avatar01 from "./png/avatar_01.png";
import avatar02 from "./png/avatar_02.png";
import avatar03 from "./png/avatar_03.png";
import avatar04 from "./png/avatar_04.png";
import avatar05 from "./png/avatar_05.png";
import avatar06 from "./png/avatar_06.png";
import ejlogoFondo from './png/logos/ej_logo_con_fondo.png';
import icoed360 from './png/icoeduca360.png';
import icoedver from './png/icoeducaverse.png';
import icoedujob from './png/icoeducajob.png';
import logoE360 from './png/Educa360Logo.png';
import fondoEduca from './jpg/FondoEduca360.jpg';
import partnerAvatar from './png/chatbot_avatar/partnerAvatar.png';
import studentAvatar from './png/chatbot_avatar/studentAvatar.png';
import teacherAvatar from './png/chatbot_avatar/teacherAvatar.png';
import institutionAvatar from './png/chatbot_avatar/institutionAvatar.png';

const Icon={
    LogoWhite,
}
const logoEduca={
    logoE360,
}

const image = {
    authBg,
    homeBanner,
    noAvatar,
    academyLogo,
    avatar01,
    avatar02,
    avatar03,
    avatar04,
    avatar05,
    avatar06,
    ejlogoFondo,
    icoed360,
    icoedver,
    icoedujob,
    partnerAvatar,
    studentAvatar,
    teacherAvatar,
    institutionAvatar,
    educabanner,
    fondoEduca
}

export {
    Icon,
    image,
    logoEduca,
};
